import { ComponentPropsWithoutRef } from 'react';
import { CurrencyInputField } from './CurrencyInputField';
import { Typography } from '../components/Typography';

type FieldProps = ComponentPropsWithoutRef<typeof CurrencyInputField>;

type FuelRollbackAmountFieldProps = Omit<FieldProps, 'InputProps'> & {
  InputProps?: Omit<NonNullable<FieldProps['InputProps']>, 'endAdornment'>;
};

export const FuelRollbackAmountField = (props: FuelRollbackAmountFieldProps) => {
  const { InputProps, label, ...rest } = props;

  return (
    <CurrencyInputField
      {...rest}
      label={label ?? 'Dollar(s) off'}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <Typography
            sx={{ pl: '4px' }}
            flexShrink={0}
            variant='body1'
            noWrap
            color='textSecondary'
            align='center'
          >
            per gallon
          </Typography>
        ),
      }}
    />
  );
};
